import React, { useState, useEffect } from "reactn";
import PropTypes from "prop-types";
import appHook from "../../../../hooks/appHook";

// components
import Input from "shared-anpost-components/components/form/input/Input";
import Select from "shared-anpost-components/components/form/select/Select";
import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Label from "shared-anpost-components/components/form/label/Label";
import AddElement from "shared-anpost-components/components/form/addElement/AddElement";
import Error from "../../form/formError/FormError";
import Loader from "shared-anpost-components/components/loader/Loader";
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";

// APIs
import { getCountries, getJWTInfo } from "../../../../services/Api";

const AddressInternational = props => {
    const { handleChange, handleKeyup, handleBlur, values, errors, addressId } = props;
    const { handleFocus, focus } = appHook();
    const [lineThree, setLineThree] = useState(false);
    const [lineFour, setLineFour] = useState(false);
    const [countries, setCountries] = useState([]);

    const [loader, setLoader] = useState(false);

    const [ApiError, setApiError] = useState(false); // state to handle API error

    const handleError = () => {
        setLoader(false);
        setApiError(true);
    };

    const closeFunc = () => {
        setApiError(false);
    };

    const handleCountryChange = e => {
        const el = e.target;
        // set the country code
        values[`${addressId}intCountryCode`] = el.options[el.selectedIndex].getAttribute("data-value");

        // set the country value, used for passing to the APIs
        values[`${addressId}Country`] = el.value;

        // do default behaviour
        handleChange(e);
    };

    useEffect(() => {
        // if the country value exists, set the country code
        if (values[`${addressId}intCountry`] && countries.length > 0) {
            const selectedCountry = countries.filter(item => {
                return item.value === values[`${addressId}intCountry`];
            })[0];

            // set the country code
            if (selectedCountry) {
                values[`${addressId}intCountryCode`] = selectedCountry.available;
            }
        }
    }, [countries]);

    useEffect(() => {
        setLoader(true);
        getJWTInfo().then(() => {
            getCountries()
                .then(res => {
                    if (res.status === 200) {
                        setLoader(false);
                        const tempCountries = res.data.Response;

                        // set countries for use by country dropdown
                        setCountries(
                            tempCountries
                                .filter(item => {
                                    return item.CountryName !== "Ireland";
                                })
                                .map(item => {
                                    return {
                                        id: item.CountryName,
                                        available: item.CountryCode,
                                        value: item.CountryName
                                    };
                                })
                        );
                    } else {
                        handleError();
                    }
                })
                .catch(() => {
                    handleError();
                });
        });
    }, []);
    return (
        <>
            {loader && <Loader />}
            {ApiError && <GlobalError closeFunc={closeFunc} />}
            <FormGroup error={errors[`${addressId}Addresslineone`]} focused={focus === `${addressId}Addresslineone` ? true : !!(false || values[`${addressId}Addresslineone`])}>
                <InputGroup>
                    <Label htmlFor={`${addressId}Addresslineone`} text="Address Line 1" />
                    <Input
                        id={`${addressId}Addresslineone`}
                        type="text"
                        name={`${addressId}Addresslineone`}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[`${addressId}Addresslineone`] || ""}
                        maxLength="50"
                    />
                </InputGroup>
                {errors[`${addressId}Addresslineone`] && <Error title={errors[`${addressId}Addresslineone`]} />}
            </FormGroup>
            <FormGroup error={errors[`${addressId}Addresslinetwo`]} focused={focus === `${addressId}Addresslinetwo` ? true : !!(false || values[`${addressId}Addresslinetwo`])}>
                <InputGroup>
                    <Label htmlFor={`${addressId}Addresslinetwo`} text="Address Line 2" />
                    <Input
                        id={`${addressId}Addresslinetwo`}
                        type="text"
                        name={`${addressId}Addresslinetwo`}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[`${addressId}Addresslinetwo`] || ""}
                        maxLength="50"
                    />
                </InputGroup>
                {errors[`${addressId}Addresslinetwo`] && <Error title={errors[`${addressId}Addresslinetwo`]} />}
            </FormGroup>
            {!lineThree && !values[`${addressId}Addresslinethree`] && (
                <AddElement click={() => setLineThree(true)}>
                    <p>
                        <span>+</span>Add an address line
                    </p>
                </AddElement>
            )}
            {(lineThree || values[`${addressId}Addresslinethree`]) && (
                <>
                    <FormGroup error={errors[`${addressId}Addresslinethree`]} focused={focus === `${addressId}Addresslinethree` ? true : !!(false || values[`${addressId}Addresslinethree`])}>
                        <InputGroup>
                            <Label htmlFor={`${addressId}Addresslinethree`} text="Address Line 3" />
                            <Input
                                id={`${addressId}Addresslinethree`}
                                type="text"
                                name={`${addressId}Addresslinethree`}
                                change={handleChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[`${addressId}Addresslinethree`] || ""}
                                maxLength="50"
                            />
                        </InputGroup>
                        {errors[`${addressId}Addresslinethree`] && <Error title={errors[`${addressId}Addresslinethree`]} />}
                    </FormGroup>
                    {!lineFour && !values[`${addressId}Addresslinefour`] && (
                        <AddElement click={() => setLineFour(true)}>
                            <p>
                                <span>+</span>Add an address line
                            </p>
                        </AddElement>
                    )}
                </>
            )}
            {(lineFour || values[`${addressId}Addresslinefour`]) && (
                <FormGroup error={errors[`${addressId}Addresslinefour`]} focused={focus === `${addressId}Addresslinefour` ? true : !!(false || values[`${addressId}Addresslinefour`])}>
                    <InputGroup>
                        <Label htmlFor={`${addressId}Addresslinefour`} text="Address Line 4" />
                        <Input
                            id={`${addressId}Addresslinefour`}
                            type="text"
                            name={`${addressId}Addresslinefour`}
                            change={handleChange}
                            keyup={handleKeyup}
                            focus={handleFocus}
                            blur={handleBlur}
                            value={values[`${addressId}Addresslinefour`] || ""}
                            maxLength="50"
                        />
                    </InputGroup>
                    {errors[`${addressId}Addresslinefour`] && <Error title={errors[`${addressId}Addresslinefour`]} />}
                </FormGroup>
            )}
            <FormGroup error={errors[`${addressId}City`]} focused={focus === `${addressId}City` ? true : !!(false || values[`${addressId}City`])}>
                <InputGroup>
                    <Label htmlFor={`${addressId}City`} text="City / State" />
                    <Input
                        id={`${addressId}City`}
                        type="text"
                        name={`${addressId}City`}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[`${addressId}City`] || ""}
                        maxLength="50"
                    />
                </InputGroup>
                {errors[`${addressId}City`] && <Error title={errors[`${addressId}City`]} />}
            </FormGroup>
            <FormGroup error={errors[`${addressId}PostCode`]} focused={focus === `${addressId}PostCode` ? true : !!(false || values[`${addressId}PostCode`])}>
                <InputGroup>
                    <Label htmlFor={`${addressId}PostCode`} text="Post code (optional)" />
                    <Input
                        id={`${addressId}PostCode`}
                        type="text"
                        name={`${addressId}PostCode`}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[`${addressId}PostCode`] || ""}
                        maxLength="10"
                    />
                </InputGroup>
                {errors[`${addressId}PostCode`] && <Error title={errors[`${addressId}PostCode`]} />}
            </FormGroup>
            <FormGroup error={errors[`${addressId}intCountry`]}>
                <Select
                    id={`${addressId}intCountry`}
                    type="text"
                    name={`${addressId}intCountry`}
                    focused={focus === `${addressId}intCountry` ? true : !!(false || values[`${addressId}intCountry`])}
                    change={handleCountryChange}
                    keyup={handleKeyup}
                    focus={handleFocus}
                    blur={handleBlur}
                    labelText="Country"
                    defaultValue="Country"
                    options={countries}
                    selectedValue={values[`${addressId}intCountry`] || ""}
                />
                {errors[`${addressId}intCountry`] && <Error title={errors[`${addressId}intCountry`]} />}
            </FormGroup>
        </>
    );
};

AddressInternational.propTypes = {
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    addressId: PropTypes.string
};

export default AddressInternational;
